import * as S from './styles'

export type ToggleButtonProps = {
  id?: string
  height?: number
  content?: string
  active: boolean
  disabled?: boolean
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  id,
  height = 30,
  content,
  active,
  disabled,
  onClick
}) => {
  return (
    <S.StyledButton
      id={id}
      height={height}
      active={active}
      disabled={disabled}
      onClick={onClick}
    >
      {!!content && <S.ButtonText>{content}</S.ButtonText>}
    </S.StyledButton>
  )
}
